<template>
  <h1 v-t="'error.404.title'"/>
</template>

<script>
  export default {
    name: 'Error404'
  }
</script>
